import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotFound from '../views/404';
import ConfigurationError from '../views/ConfigurationError';
import Register from '../auth/Register';
import Login from '../auth/Login';

import Courses from '../views/Courses';
import Dashboard from '../views/Dashboard';
import FAQ from '../views/FAQ';
import FindACoach from '../views/FindACoach';
import FullTest from '../views/FullTest';
import MyDynamics from '../views/MyDynamics';
import MyGoals from '../views/MyGoals';
import ShortTest from '../views/ShortTest';
import TeamDynamics from '../views/TeamDynamics';
import Workshops from '../views/Workshops';
import Contact from '../views/Contact';
import MyProfile from '../views/MyProfile';
import Billing from '../views/Billing';
import VerificationEmailSent from '../auth/VerficiationEmailSent';
import FirebaseHandler from '../auth/Handler';
import ForgotPassword from '../auth/ForgotPassword';

const Routing = () => {
  const user = useSelector(state => state.User);

  return (
    <Routes>
      <Route path="/handler" element={<FirebaseHandler />} />
      {user?.validUser && !user.session.emailVerified ? (
        <>
          <Route path="*" element={<VerificationEmailSent />} />
        </>
      ) : user?.validUser ? (
        <>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/register" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/dynamics" element={<MyDynamics />} />
          <Route path="/team" element={<TeamDynamics />} />
          <Route path="/goals" element={<MyGoals />} />
          <Route path="/mini-test" element={<ShortTest />} />
          <Route path="/full-test" element={<FullTest />} />
          <Route path="/workshops" element={<Workshops />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/coaches" element={<FindACoach />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/error" element={<ConfigurationError />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/recover" element={<ForgotPassword />} />
        </>
      ) : (
        <>
          <Route path="/recover" element={<ForgotPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/account-pending" element={<VerificationEmailSent />} />
          <Route path="*" element={<Login />} />
        </>
      )}
    </Routes>
  );
};
export default Routing;
